// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-o_fG","advertDetailContacts__header":"c-o_fH"};